// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-separator {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 0;
}

.date-separator-label {
	text-align: center;
	line-height: 18px;
	font-size: 12px;
	font-weight: bold;
	font-family: Roboto, Arial, sans-serif;
	color: rgb(102, 102, 102);
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/Messages/DateSeparator.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,eAAe;CACf,iBAAiB;CACjB,sCAAsC;CACtC,yBAAyB;AAC1B","sourcesContent":[".date-separator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 0;\n}\n\n.date-separator-label {\n\ttext-align: center;\n\tline-height: 18px;\n\tfont-size: 12px;\n\tfont-weight: bold;\n\tfont-family: Roboto, Arial, sans-serif;\n\tcolor: rgb(102, 102, 102);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
